export default "__VITE_ASSET__L0YMuAWY__"